import { useId, useState } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { CircleHelp } from 'lucide-react';

export default function LocationHelpLabel({ label, description }: { label: string; description: string }) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const descriptionId = useId();
  return <div>
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium text-gray-900">{label}</span>
      <button type="button" aria-label={`${t.adCreatives.locationHelpLabel}: ${label}`} aria-expanded={expanded} aria-controls={descriptionId}
        onClick={() => setExpanded(value => !value)}
        className="rounded text-gray-400 hover:text-indigo-600 focus-visible:outline-2 focus-visible:outline-indigo-500">
        <CircleHelp size={16} aria-hidden="true" />
      </button>
    </div>
    <p id={descriptionId} hidden={!expanded} className="mt-1 text-xs text-gray-500">{description}</p>
  </div>;
}
